import { RoomsStateInterface } from '.';

function state(): RoomsStateInterface {
  return {
    rooms: [],
  };
}

export default state;
